import * as yup from 'yup';
import Decimal from 'decimal.js';

const MAX_HYPOTHETICAL_RETURN = 12;

export const hypotheticalReturnValidation = yup
  .mixed()
  .test({
    name: 'isValid',
    message: 'Please specify a valid Straight-line Projected Return',
    test: value => {
      if (!value) {
        return true;
      }

      try {
        new Decimal(value).div(100).toNumber();

        return true;
      } catch {
        return false;
      }
    },
  })
  .test({
    name: 'isNegative',
    message: 'Straight-line Projected Return cannot be negative',
    test: value => {
      if (!value) {
        return true;
      }

      try {
        const parsedValue = new Decimal(value).div(100).toNumber();

        return parsedValue >= 0;
      } catch {
        return true;
      }
    },
  })
  .test({
    name: 'isGreaterThanMax',
    message: `Straight-line Projected Return cannot be greater than ${MAX_HYPOTHETICAL_RETURN}%`,
    test: value => {
      if (!value) {
        return true;
      }

      try {
        const parsedValue = new Decimal(value).div(100).toNumber();

        const maxHypotheticalReturn = new Decimal(MAX_HYPOTHETICAL_RETURN).div(100).toNumber();

        return parsedValue >= 0 && parsedValue <= maxHypotheticalReturn;
      } catch {
        return true;
      }
    },
  });
